import CompetitorResultsApp from "./CompetitorResultsApp.vue";
import { vueAppWithPinia } from "../Common/vueApp";

export default vueAppWithPinia(CompetitorResultsApp);
